import _ from 'lodash';
import store from './store';

const permissions = {
  isPermittedAll(permissionCodes) {
    const allowedPermissionCodes = _.map(
      store.state.userPermissions,
      'PermissionCode',
    );

    if (!permissionCodes) {
      return true;
    }

    return _.intersection(
      allowedPermissionCodes,
      permissionCodes,
    ).length === permissionCodes.length;
  },
  isPermittedAtLeastOne(permissionCodes) {
    const allowedPermissionCodes = _.map(
      store.state.userPermissions,
      'PermissionCode',
    );

    if (!permissionCodes) {
      return true;
    }

    return _.intersection(
      allowedPermissionCodes,
      permissionCodes,
    ).length > 0;
  },
  isPermittedAllAsync(permissionCodes) {
    return new Promise((resolve) => {
      const interval = setInterval(() => {
        if (store.state.userPermissions.length > 0) {
          const isPermitted = this.isPermittedAllAsync(permissionCodes);
          resolve(isPermitted);
          clearInterval(interval);
        }
      }, 50);
    });
  },
  isPermittedAtLeastOneAsync(permissionCodes) {
    return new Promise((resolve) => {
      const interval = setInterval(() => {
        if (store.state.userPermissions.length > 0) {
          const isPermitted = this.isPermittedAtLeastOne(permissionCodes);
          resolve(isPermitted);
          clearInterval(interval);
        }
      }, 50);
    });
  },
};

const permissionsMixin = {
  methods: permissions,
};

export {
  permissions,
  permissionsMixin,
};
